<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-dialog
      v-model="dialog"
      max-width="400"
    >
      <LidarsInfoCard 
        :allow_gpu_algo_node=currentLicenseAllowGPUAlgoNode 
        :max_algo_node_count=currentLicenseMaxAlgoNodeCount 
        :max_lidar_count=currentLicenseMaxLidarCount 
        :lidars=currentLicenseLidars
        :allow_features=currentLicenseAllowFeatures
        v-on:closeDialog="dialog = false">
      </LidarsInfoCard>
    </v-dialog>

    <v-row justify="center">
      <v-col cols="12">
        <material-card
          color="sr_gray" 
          title="License Activations"
        >
          <v-data-table
            :headers="headers"
            :items="licenses"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:item.machine_name="props">
              <v-edit-dialog
                :return-value.sync="props.item.machine_name"
                @save="saveItemNameEdit(props.item)"
                @open="openItemNameEdit(props.item)"
              > {{ props.item.machine_name }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.machine_name"
                    label="Edit"
                    single-line
                    counter
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </template>

            <template v-slot:item.actions="{ item }">
              <div v-if="shouldShowUpload(item)">
                <input type="file" ref="file" style="display: none" v-on:change="uploadKey( $event.target.files )">
                <v-btn color="primary" class="sr_gray--text" @click="startUploadKey(item)">Upload Machine Key</v-btn>
              </div>
              <v-btn color="primary" class="sr_gray--text" @click="downloadKey(item)" v-else>Download License</v-btn>
            </template>

            <template v-slot:item.explore_lidars="{ item }">
              <v-btn text icon @click="showLidarInfo(item)">
                <v-icon>search</v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-col>

    </v-row>
    
  </v-container>
</template>

<script>
  import RestHelper from './../plugins/rest_helpers.js'
  import LidarsInfoCard from './../components/LidarsInfoCard'

  export default {
    components: {
      LidarsInfoCard: LidarsInfoCard,
    },
    methods: {
      shouldShowUpload : function(item) {
        return item.machine_key == "Invalid";
      },
      showLidarInfo : function(item) {
        this.selectedLicense = item;
        this.dialog = true;
      },
      startUploadKey : function(item) { 
        this.editedItem = item;
        this.$refs.file.click();
      },
      downloadKey : function(item) { 
        var itemIndex = this.licenses.indexOf(item);
        var licenseGuid = Array.from(this.licensesMap.keys())[itemIndex];
        RestHelper.downloadLicenseFile(licenseGuid)
          .then( response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item.machine_name + '_license.lic');
            document.body.appendChild(link);
            link.click();
          })
          .catch( e => { 
            void(e)
            this.$store.dispatch("showFailureSnack", "An error has occurred")
          });
      },
      uploadKey : function(fileList) { 
        if (!fileList.length) return;

        var itemIndex = this.licenses.indexOf(this.editedItem);
        var licenseGuid = Array.from(this.licensesMap.keys())[itemIndex];
        const file = fileList[0];
        file.text().then( (result) => {
          var id = JSON.parse(result).id;
          RestHelper.uploadLicenseFile(licenseGuid, id)
            .then( s => {
              void(s)
              this.$store.dispatch("showSuccessSnack", "Successfully uploaded!")
              this.editedItem.machine_key = "Valid";
            })
        }).catch( e => { 
            void(e)
            this.$store.dispatch("showFailureSnack", "An error has occurred")
          });
      },
      openItemNameEdit : function(item) { 
        this.lastName = item.machine_name;
      },
      saveItemNameEdit : function(item) {
        var itemIndex = this.licenses.indexOf(item);
        var licenseGuid = Array.from(this.licensesMap.keys())[itemIndex];
        RestHelper.renameLicense(this.$store.getters.currentUserSub, licenseGuid, item.machine_name)
          .then( s => {
            void(s)
            this.$store.dispatch("showSuccessSnack", "Successfully renamed!")
          })
          .catch( e => { 
            void(e)
            this.$store.dispatch("showFailureSnack", "An error has occurred")
            // Restore the previous value.
            item.machine_name = this.lastName;
          });
      }
    },
    data: () => ({
      headers: [
        {
          sortable: false,
          text: 'Machine Name',
          value: 'machine_name'
        },
        {
          sortable: false,
          text: 'Expiration Date',
          value: 'expiration_date'
        },
        {
          sortable: false,
          text: 'Machine License',
          value: 'actions'
        },
        {
          sortable: false,
          text: 'Detail',
          value: 'explore_lidars'
        }
      ],
      dialog: false,
      selectedLicense : null
    }),
    computed : {
      licenses() { 
        if( this.$store.state.licenseData != null ) { 
          return Array.from(this.$store.state.licenseData.values());
        }
        return [];
      },
      licensesMap() { 
        return this.$store.state.licenseData;
      },
      currentLicenseAllowGPUAlgoNode() {
        if( this.selectedLicense != null ) {
          return this.selectedLicense.allow_gpu_algo_node;
        } else {
          return this.selectedLicense;
        }
      },
      currentLicenseMaxAlgoNodeCount() {
        if( this.selectedLicense != null ) {
          return this.selectedLicense.max_algo_node_count;
        } else {
          return this.selectedLicense;
        }
      },
      currentLicenseMaxLidarCount() {
        if( this.selectedLicense != null ) {
          return this.selectedLicense.max_lidar_count;
        } else {
          return this.selectedLicense;
        }
      },
      currentLicenseLidars() { 
        if( this.selectedLicense != null ) {
          var allowance_map = new Map(JSON.parse(this.selectedLicense.hardware_allowance));
          var display_map = new Map();
          for (let pair of allowance_map) {
            display_map.set(this.$store.state.availableLidars.get(pair[0]), pair[1]);
          }
          return display_map;
        } else {
          return this.selectedLicense;
        }
      },
      currentLicenseAllowFeatures() { 
        if( this.selectedLicense != null) {
          let allow_features = this.selectedLicense.allow_features;
          if (typeof(allow_features) !== 'undefined') {
            return new Array(allow_features);
          } else {
            return new Array();
          }
        } else {
          return this.selectedLicense;
        }
      }
    }
  }
</script>
